import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import CancelIcon from "@material-ui/icons/Cancel";
import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import GeneralAuthentication from "../general/GeneralAuthentication";
import TwoPanesPanel from "../general/TwoPanesPanel";
import MainPane from "../general/MainPane";
import LeftPaneGeneral from "../general/LeftPaneGeneral";
import BackToApplication from "../general/BackToApplication";
import { TwoHeading } from "../general/TwoHeading";
import * as theme from "../theme";
import ActionButton from "../general/ActionButton";
import PerfectScrollbar from "react-perfect-scrollbar";
import SelectDropdown from "react-select";
import { capitalizeFirstLetter } from "../utils/utils";

import "./reminder.css";
import {
  getGettingMyBinders,
  getGettingMyBindersSuccess,
  getMyBinders,
  getStatus,
  getBrokers,
  getBinders,
} from "../store/mybinder";

import { getPolicyStatusData } from "../store/policyStatus";
import { getStatusApi } from "../store/policyStatus";
import Loader3Orange from "../general/Loader3Orange";
import {
  getBrokerTeamInfo,
  getBrokerTeamMembers,
  getScrollResponsesDiv,
} from "../store/quotes";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import NormalText from "../general/NormalText";
import {
  activateNavigationPage,
  getCreateReminderModalState,
  getOtherStatusModalState,
  reminderModalClosed,
  reminderModalOpened,
  reminderModalSet,
  reminderOtherStatusClosed,
  reminderOtherStatusOpened,
  setautoreminder,
} from "../store/components";
import { OrangeButton } from "../general/OrangeButton";
import moment from "moment";
import { PossibleNaviationPages } from "../components/Navigation";
import Typography from "@material-ui/core/Typography";
import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import Select from "react-dropdown-select";
import CreateReminderModal from "./ReminderModal";
import { getMyQuotes } from "../store/myquotes";
import {
  clientDetailsForReminder,
  getCategoryList,
  getClientList,
  getGroupList,
  getGroupSelectArray,
  getMyReminders,
  getReminderCategoryList,
  getReminderSingleObject,
  getReminderView,
  getRowDetailsFromReminderProspectId,
  getreminderArrayResp,
  getreminderStatusUpdate,
  gettingReminderSingleObject,
  reminderSingleObjectClear,
  updateReminderStatus,
  getRemindersSuccessValue,
} from "../store/myreminder";
import { getBrokerInformation } from "../store/broker";
import { toast } from "react-toastify";
import {
  CATEGORY,
  CREATOR,
  CUSTOM,
  END_DATE,
  GROUP,
  ME,
  MONTH,
  TODAY,
  OTHER,
  OWNER,
  POLICY,
  PROSPECT,
  START_DATE,
  STATUS_KEY,
  WEEK,
  YEAR,
  dateOptionList,
  reminderList,
  statusList,
  getTranslatedOptions,
} from "../helper/constants";
import {
  FormateDate,
  setReminderDate,
  FormattedDate,
} from "../store/helperfuncs";
import { Link, useNavigate, useLocation } from "react-router-dom";
import externaltranslations from "../utils/translations";
import frLocale from "date-fns/locale/fr";
import enLocale from "date-fns/locale/en-US";

const useStyles = makeStyles(theme.customMaterialUIClassForScrollBar);

const translations = {
  en: {
    backToHomePage: "Back To Homepage",
    custom: "Custom",
    today: "Today and Past Due",
    select: "Select ...",
    view: "View",
    updateReminder: "Update Reminder",
    createNewReminder: "Create New Reminder",
    reminderTitle: "Reminder Title",
    titleOfReminder: "Title of reminder",
    reminderForMe: "Reminder For Me",
    status: "Status",
    selectAnOption: "Select an option",
    individualOrTeam: "Individual or Team",
    owner: "Owner",
    reminderFor: "Reminder For",
    selectAnOptionEllipsis: "Select an option...",
    category: "Category",
    selectADate: "Select a date",
    description: "Description",
    descriptionOfReminder: "Description of reminder",
    sendEmailNotificationToOwner: "Send email notification to owner",
    reminderDate: "Reminder Date",
    addNewReminderButton: "Add New Reminder",

    filters: "Filters",
    searchForClient: "Search for a Client",
    dueDate: "Due Date",
    from: "From",
    to: "To",
    all: "All",
    everyone: "Everyone",
    creator: "Creator",
    userGroup: "User Group",
    clearFilters: "Clear Filters",
    noreminderData: "No Reminders data found",
    columnHeadingsReminders: {
      first: "Date created",
      second: "Creator",
      third: "Reminder",
      fourth: "Category",
      fifth: "Owner",
      sixth: "Client Name",
      seventh: "Due date",
      eighth: "Status",
      ninth: "Action",
    },

    reminderHeader: {
      heading1: "Reminders & Actions",
      heading2: "Filter or scroll through your reminders",
    },
  },
  fr: {
    backToHomePage: "Retour page d’accueil",
    custom: "Personnalisé",
    today: "Aujourd'hui",
    select: "Sélectionner ...",
    view: "Reviser",
    addNewReminderButton: "Ajouter un nouveau rappel",
    updateReminder: "Mettre à jour le rappel",
    createNewReminder: "Créer un nouveau rappel",
    reminderTitle: "Titre du rappel",
    titleOfReminder: "Titre du rappel",
    reminderForMe: "Rappel pour moi",
    status: "Ouvert",
    selectAnOption: "Sélectionner une option",
    individualOrTeam: "Individuel ou Équipe",
    owner: "Propriétaire",
    reminderFor: "Rappel pour",
    selectAnOptionEllipsis: "Sélectionner une option...",
    category: "Étape",
    selectADate: "Sélectionner une date",
    description: "Description",
    descriptionOfReminder: "Description du rappel",
    sendEmailNotificationToOwner:
      "Envoyer une notification par e-mail au propriétaire",
    reminderDate: "Date du rappel",

    filters: "Filtres",
    searchForClient: "Rechercher un client",
    dueDate: "Date de suivi",
    from: "De",
    to: "À",
    all: "Tous",
    everyone: "Tout le monde",
    creator: "Saisi par",
    userGroup: "Groupe d'utilisateurs",
    clearFilters: "Effacer les filtres",
    noreminderData: "Aucune donnée de rappel trouvée",
    columnHeadingsReminders: {
      first: "Date d'ouverture",
      second: "Saisi par",
      third: "Nom du rappel",
      fourth: "Étape",
      fifth: "Propriétaire",
      sixth: "Nom du client",
      seventh: "Date du suivi",
      eighth: "Statut",
      ninth: "Action",
    },
    reminderHeader: {
      heading1: "Rappels & Suivis",
      heading2:
        "Utiliser le filtre ou sélectionner une page ci-dessous pour voir tous vos rappels.",
    },
  },
};

const Reminders = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      activateNavigationPage({ pagecode: PossibleNaviationPages.reminders })
    );
  }, []);

  const [filteredParams, setFilteredParams] = useState({});
  const [query, setQuery] = useState("");
  const [reminderFilter, setReminderFilter] = useState("me");
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [creatorFilter, setCreatorFilter] = useState("");
  const [userGroupFilter, setUserGroupFilter] = useState("");
  const [ownerFilter, setOwnerFilter] = useState("");
  const [note, setNote] = useState("");
  const [reminderRedirection, setreminderRedirection] = useState({
    isOpen: false,
    link: "",
    reminder: null,
  });
  const createReminderModal = useSelector(getCreateReminderModalState);
  const otherReminderModal = useSelector(getOtherStatusModalState);
  const brokerage = useSelector(getBrokerInformation);
  const languagePreference = brokerage?.information?.languagepreference || "en";

  return (
    <>
      <Modal
        isOpen={createReminderModal}
        ariaHideApp={false}
        disableEscapeKeyDown={false}
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
            color: "white",
          },
          content: {
            height: "83vh",
            width: "35vw",
            position: "absolute",
            top: "6vh",
            left: "29vw",
            right: 0,
            bottom: 0,
            background: "white",
            WebkitOverflowScrolling: "touch",
            border: `8px solid white`,
            borderRadius: "20px",
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <CreateReminderModal></CreateReminderModal>
      </Modal>
      <Modal
        isOpen={otherReminderModal}
        ariaHideApp={false}
        shouldCloseOnEsc={false}
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
            color: "white",
          },
          content: {
            height: "60%",
            width: "36vw",
            position: "absolute",
            top: "18vh",
            left: "28vw",
            right: 0,
            bottom: 0,
            background: "white",
            WebkitOverflowScrolling: "touch",
            border: `8px solid white`,
            borderRadius: "20px",
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <OtherStatusModal
          note={note}
          setNote={setNote}
          reminderFilter={reminderFilter}
        ></OtherStatusModal>
      </Modal>
      <CompleteReminderModal
        setreminderRedirection={setreminderRedirection}
        reminderRedirection={reminderRedirection}
      />
      <GeneralAuthentication>
        <MainPane hideHelpOrTip={true}>
          <TwoPanesPanel
            myquotesscreen={true}
            myquotesleftpane={
              <RemindersLeftPane
                query={query}
                userGroupFilter={userGroupFilter}
                ownerFilter={ownerFilter}
                statusFilter={statusFilter}
                creatorFilter={creatorFilter}
                categoryFilter={categoryFilter}
                reminderFilter={reminderFilter}
                startDateFilter={startDateFilter}
                endDateFilter={endDateFilter}
                setreminderRedirection={setreminderRedirection}
              />
            }
            myquotesrightpane={
              <RemindersRightPane
                setFilteredParams={setFilteredParams}
                filteredParams={filteredParams}
                userGroupFilter={userGroupFilter}
                ownerFilter={ownerFilter}
                statusFilter={statusFilter}
                creatorFilter={creatorFilter}
                categoryFilter={categoryFilter}
                reminderFilter={reminderFilter}
                endDateFilter={endDateFilter}
                setQuery={setQuery}
                query={query}
                startDateFilter={startDateFilter}
                endDateFilter={endDateFilter}
                setUserGroupFilter={setUserGroupFilter}
                setOwnerFilter={setOwnerFilter}
                setStatusFilter={setStatusFilter}
                setCreatorFilter={setCreatorFilter}
                setCategoryFilter={setCategoryFilter}
                setReminderFilter={setReminderFilter}
                setStartDateFilter={setStartDateFilter}
                setEndDateFilter={setEndDateFilter}
              />
            }
          ></TwoPanesPanel>
        </MainPane>
      </GeneralAuthentication>
    </>
  );
};

//#region  Left Pane

const RemindersLeftPane = (props) => {
  const dispatch = useDispatch();
  const brokerteam = useSelector(getBrokerTeamMembers);
  const history = useNavigate();
  const userInformation = useSelector(getBrokerInformation);
  const languagePreference = userInformation?.information?.languagepreference || "en";
  const reminderModalOpenHandler = () => {
    dispatch(reminderModalSet(true));
  };
  let heightDivison = {
    backtoapp: "9%",
    quoteresults: "11%",
    tableheader: "75px",
    bottommargin: "4vmin",
    spaceBetweenHeaderContent: "0px",
    responses: "",
  };

  heightDivison.responses = `calc(100% - ${heightDivison.backtoapp} - ${heightDivison.quoteresults} - ${heightDivison.tableheader} - ${heightDivison.bottommargin} - ${heightDivison.spaceBetweenHeaderContent})`;
  const mainContMargin = "5vw";

  return (
    <>
      <div className="addButton">
        <Button
          style={{
            color: "white",
            height: "5.6vmin",
            fontFamily: "GibsonSemiBd",
            fontSize: "1.5vmin",
            border: 0,
            width: "9vw",
            borderRadius: "1.1vmin",
            display: "flex",
            backgroundColor: theme.COLORS.secondary_orange,
            justifyContent: "center",
            alignItems: "center",
            letterSpacing: 1,
            cursor: "pointer",
          }}
          onClick={() => {
            dispatch(setautoreminder({}));
            dispatch(reminderModalSet(true));
          }}
        >
          {translations[languagePreference].addNewReminderButton}
        </Button>
      </div>
      <LeftPaneGeneral
        heightDivison={heightDivison}
        backToApplication={
          <BackToApplication
            text={translations[languagePreference].backToHomepage}
            onClick={() => {
              history("/");
            }}
          ></BackToApplication>
        }
        headingSection={
          <div
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <TwoHeading
              heading1={
                translations[languagePreference].reminderHeader.heading1
              }
              heading2={
                translations[languagePreference].reminderHeader.heading2
              }
            ></TwoHeading>
          </div>
        }
        tableHeaderSection={<RemindersTableHeader></RemindersTableHeader>}
        tableRowsSection={
          <RemindersTable
            heightDivison={heightDivison}
            reminderFilter={props.reminderFilter}
          >
            <RemindersTableRow
              query={props.query}
              userGroupFilter={props.userGroupFilter}
              ownerFilter={props.ownerFilter}
              statusFilter={props.statusFilter}
              creatorFilter={props.creatorFilter}
              reminderFilter={props.reminderFilter}
              categoryFilter={props.categoryFilter}
              startDateFilter={props.startDateFilter}
              endDateFilter={props.endDateFilter}
              heightDivison={heightDivison}
              mainContMargin={mainContMargin}
              setreminderRedirection={props.setreminderRedirection}
            ></RemindersTableRow>
          </RemindersTable>
        }
      ></LeftPaneGeneral>
    </>
  );
};

const SomethingFailedGettingReminders = () => {
  return <div>Something failed getting my quotes, please contact admin.</div>;
};

const RemindersTable = (props) => {
  const dispatch = useDispatch();
  const { heightDivison } = props;
  const getReminderSuccess = useSelector(getRemindersSuccessValue);
  // function setReminderDate(fromDate, toDate) {
  //   const startDate = fromDate;
  //   const endDate = toDate;
  //   startDate.setHours(0, 0, 0, 0);
  //   endDate.setHours(23, 59, 59, 999);
  //   return { startDate, endDate };
  // }
  useEffect(() => {
    const date = setReminderDate(new Date(), new Date());
    const filterParams = {
      reminderfilter: props.reminderFilter,
      fromreminderdate: date.startDate,
      toreminderdate: date.endDate,
    };
    dispatch(getMyQuotes(null));
    dispatch(getStatusApi());
    dispatch(getReminderCategoryList());
    dispatch(getMyReminders());
    dispatch(getGroupList());
    dispatch(getClientList());
    dispatch(getReminderView());
  }, []);
  const policyStatusData = useSelector(getPolicyStatusData);
  const reminderList = useSelector(getreminderArrayResp);

  const { information } = useSelector(getBrokerInformation);
  const languagePreference = information?.languagepreference || "en";
  useEffect(() => {
    let code = information.brokeragecode;
    dispatch(getBrokerTeamInfo({ brokeragecode: code }));
  }, [information]);
  useEffect(() => {
    let statusid = "";
    policyStatusData &&
      policyStatusData?.policystatus?.map((status) => {
        if (status.name === "BINDER") {
          statusid = status._id;
          return [];
        }
      });
    if (statusid !== "") {
      dispatch(
        getMyBinders({
          statusid,
        })
      );
    }
  }, [policyStatusData]);

  return (
    <>
      {reminderList.length === 0 ? (
        <p
          style={{
            textAlign: "center",
            marginTop: "2%",
            color: "grey",
            fontFamily: "sans-serif",
            fontSize: "20px",
          }}
        >
          {translations[languagePreference].noreminderData}
        </p>
      ) : null}
      {getReminderSuccess && props.children}
    </>
  );
};

const RemindersTableRow = (props) => {
  const isScrollResponsesDiv = useSelector(getScrollResponsesDiv);
  const reminderList = useSelector(getreminderArrayResp);
  const responsesDiv = useRef(null);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const ColoumnWidth = theme.columnWidthReminderTable;
  ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third} - ${ColoumnWidth.fourth} - ${ColoumnWidth.fifth}  - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;
  const classes = useStyles();
  const itemsPerPage = 10;
  const maxPages = 10;
  // Logic for displaying page numbers
  const pageNumbers = [];
  const totalPages = Math.ceil(
    reminderList.filter((item) =>
      item.clientName?.toLowerCase().includes(props.query?.toLowerCase())
    ).length / itemsPerPage
  );
  const arrPageLimiter = [totalPages, maxPages];
  for (let i = 1; i <= Math.min(...arrPageLimiter); i++) {
    pageNumbers.push(i);
  }
  return (
    <div
      style={{
        width: "100%",
        height: props.heightDivison.responses,
        paddingLeft: props.mainContMargin,
        paddingRight: isScrollResponsesDiv
          ? `calc(${props.mainContMargin} - ${theme.SCALES.scrollbarThickness} - ${theme.SCALES.responsesSpacesBetweenScroll})`
          : props.mainContMargin,
      }}
    >
      <div
        className={classes.responses}
        style={{
          width: "100%",
          paddingRight: isScrollResponsesDiv
            ? theme.SCALES.responsesSpacesBetweenScroll
            : "0px",
          height: "100%",
          overflow: "auto",
        }}
        ref={responsesDiv}
      >
        {reminderList
          ?.filter((item) =>
            item?.clientName?.toLowerCase().includes(props.query?.toLowerCase())
          )
          ?.map((reminder, x) =>
            x >= (currentPage - 1) * itemsPerPage &&
            x < currentPage * itemsPerPage ? (
              <ReminderRow
                key={x}
                reminder={reminder}
                reminderFilter={props.reminderFilter}
                setreminderRedirection={props.setreminderRedirection}
              ></ReminderRow>
            ) : null
          )}
      </div>
      <div>
        <ul className="pagination justify-content-center">
          {pageNumbers.map((x) => (
            <li
              key={x}
              className={x === currentPage ? "page-item active" : "page-item"}
            >
              <a
                className="page-link"
                onClick={() => {
                  setCurrentPage(x);
                }}
              >
                {x}
              </a>
            </li>
          ))}
          {totalPages > maxPages ? (
            <li
              key={totalPages}
              className={
                totalPages === currentPage ? "page-item active" : "page-item"
              }
            >
              <input
                className="page-link"
                style={{ width: "80px" }}
                placeholder={".." + totalPages}
                type="number"
                min="1"
                max={totalPages}
                onChange={(event) => {
                  setCurrentPage(event.target.value);
                }}
              ></input>
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  );
};
const statusTranslations = {
  New: {
    fr: "Nouveau",
  },
  "App In Progress": {
    fr: "En cours",
  },
  "Close - Incomplete info": {
    fr: "Fermé - Informations incomplètes",
  },
  "App Completed": {
    fr: "Application terminée",
  },
  "In Market": {
    fr: "Sur le marché",
  },
  "Close - No Insurer": {
    fr: "Fermé - Aucun assureur",
  },
  Quoted: {
    fr: "Devis fourni",
  },
  "Not Interested": {
    fr: "Pas intéressé",
  },
  Sold: {
    fr: "Vendu",
  },
  "Send to Market": {
    fr: "Envoyer au marché",
  },
  "Continued Quote": {
    fr: "Suite du devis",
  },
  "Client Presentation": {
    fr: "Présentation client",
  },
  "Quote received": {
    fr: "Devis reçu",
  },
  "Client adjustments": {
    fr: "Ajustements clients",
  },
  "Added Insurer": {
    fr: "Assureur ajouté",
  },
  "Please review client changes during client hand-off": {
    fr: "Veuillez examiner les modifications du client lors de la remise au client.",
  },
  "Client finished Answering": {
    // Correctly placed
    fr: "Le client a fini de répondre",
  },
  Title: {
    // Correctly placed
    fr: "Titre",
  },
  "Contact client": {
    // Correctly placed
    fr: "Contacter le client",
  },
  "Send to market": {
    // Correctly placed
    fr: "Envoyer au marché",
  },
  "Send Certificate to client": {
    // Correctly placed
    fr: "Envoyer le certificat au client",
  },
  "Check in for policy documents": {
    fr: "Vérifier les documents de police",
  },
  "Await policy documents": {
    fr: "Attendre les documents de police",
  },
  "Check for quotes": {
    fr: "Vérifier les devis",
  },
  "Check insurer responses": {
    fr: "Vérifier les réponses des assureurs",
  },
};

function translateStatus(status, langPref) {
  if (statusTranslations[status] && statusTranslations[status][langPref]) {
    return statusTranslations[status][langPref];
  } else {
    // Handle cases where the status or language preference is not found
    console.warn(
      `No translation found for status "${status}" and language "${langPref}". Returning original status.`
    );
    return status; // Or you could return a default translation
  }
}
const ReminderRow = ({ reminder, reminderFilter, setreminderRedirection }) => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const reminderSingleObj = useSelector(getReminderSingleObject);
  const upadateStatusResponse = useSelector(getreminderStatusUpdate);
  const ColoumnWidth = theme.columnWidthReminderTable;
  const userInformation = useSelector(getBrokerInformation);
  const languagePreference = userInformation?.information?.languagepreference || "en";
  ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third} - ${ColoumnWidth.fourth}  - ${ColoumnWidth.fifth}   - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;
  const otherStatusModalOpenHandler = (e, reminder) => {
    const updateReminderObject = {
      reminderId: reminder?._id,
      status: e.value,
    };
    if (e.value === OTHER) {
      dispatch(reminderOtherStatusOpened());
    } else {
      dispatch(updateReminderStatus(updateReminderObject)).then(() => {
        // const filterParams = { reminderfilter: reminderFilter };
        dispatch(getMyReminders());
      });
      setTimeout(() => {
        if (upadateStatusResponse) {
          toast.success(upadateStatusResponse.message);
          dispatch(reminderSingleObjectClear());
        }
      }, 200);
    }
  };
  const commonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  };

  const borderCommon = {
    borderRight: "1px solid #D8D8D8",
  };
  const handleReminderTypeChange = (reminder) => {
    let link = null;
    if (reminder.remindertype === POLICY) {
      //window.open(`/binder?id=${reminder?.policyid}`, `_blank`);
      link = `/binder?id=${reminder?.policyid}`;
    } else if (reminder.remindertype === PROSPECT) {
      //window.open(`/prospect?id=${reminder?.prospectid}`, `_blank`);
      link = `/prospect?id=${reminder?.prospectid}`;
    } else {
      // window.open("/reminders");
    }
    setreminderRedirection({ isOpen: true, link, reminder });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "60px",
        maxHeight: 75,
        borderBottom: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        borderTop: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.first,
          ...borderCommon,
        }}
      >
        <FormattedDate
          milliseconds={reminder?.createdAt}
          languagepreference={languagePreference}
        ></FormattedDate>
        {/* <FormateDate millliseconds={reminder?.createdAt}></FormateDate> */}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.second,
          ...borderCommon,
        }}
      >
        <NormalText
          text={`${reminder?.creatorName || ""}`}
          fontWeight={"normal"}
          fontSize={15}
          color="grey"
        ></NormalText>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.third,
          ...borderCommon,
        }}
      >
        <NormalText
          text={`${
            translateStatus(
              capitalizeFirstLetter(typeof reminder?.title === 'object'
              ? reminder.title[languagePreference]
              : reminder?.title),
              languagePreference
            ) || ""
          }`}
          fontWeight={"normal"}
          fontSize={15}
          color="grey"
        ></NormalText>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.fourth,
          ...borderCommon,
        }}
      >
        <NormalText
          text={translateStatus(
            capitalizeFirstLetter(typeof reminder?.remindercategoryTitle === 'object'
            ? reminder.remindercategoryTitle[languagePreference]
            : reminder?.remindercategoryTitle),
            languagePreference
          )}
          fontWeight={"normal"}
          fontSize={15}
          color="grey"
        ></NormalText>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.fifth,
          ...borderCommon,
        }}
      >
        <NormalText
          text={
            reminder.ownertype == GROUP
              ? reminder.groupTitle
              : reminder.ownerName
          }
          fontWeight={"normal"}
          fontSize={15}
          color="grey"
        ></NormalText>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.sixth,
          ...borderCommon,
        }}
      >
        <NormalText
          onClick={() => handleReminderTypeChange(reminder)}
          text={reminder?.clientName}
          fontWeight={"normal"}
          fontSize={15}
          color="#1031b4"
          cursor={"pointer"}
        ></NormalText>
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.seventh,
          ...borderCommon,
        }}
      >
        <FormattedDate
          milliseconds={reminder?.reminderdate}
          languagepreference={languagePreference}
          utc={true}
        ></FormattedDate>
        {/* <FormateDate millliseconds={reminder?.reminderdate}></FormateDate> */}
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.eighth,
          ...borderCommon,
        }}
      >
         <SelectDropdown
          className="form-select"
          defaultValue={
            statusList.find((s) => s.value == reminder?.status)
          }
          placeholder="Select an option"
          getOptionLabel={(option) => option.label[languagePreference]}
          options={statusList}
          onChange={(e) => {
            dispatch(gettingReminderSingleObject(reminder));
            otherStatusModalOpenHandler(e, reminder);
          }}
        />
      </div>
      <div
        style={{
          ...commonStyle,
          width: ColoumnWidth.ninth,
        }}
      >
        <OrangeButton
          width={"10vmin"}
          text={externaltranslations[languagePreference].update}
          color={theme.COLORS.primary_navyblue}
          onClick={async () => {
            //dispatch(gettingReminderSingleObject(reminder));
            //await dispatch(reminderModalOpened());
            console.log(reminder);
            console.log("AUtoReminder it");
            dispatch(
              setautoreminder({
                ...reminder,
                reminderdate: reminder.reminderdate.split("T")[0],
                text: null,
                update: true,
              })
            );
          }}
        ></OrangeButton>
      </div>
    </div>
  );
};

const RemindersTableHeader = (props) => {
  const ColoumnWidth = theme.columnWidthReminderTable;
  ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third} - ${ColoumnWidth.fourth} - ${ColoumnWidth.fifth} - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;
  const userInformation = useSelector(getBrokerInformation);
  const languagePreference = userInformation?.information?.languagepreference || "en";
  const columnHeadingsReminders =
    translations[languagePreference].columnHeadingsReminders;

  // const columnHeadingsReminders = {
  //   first: "Date created",
  //   second: "Creator",
  //   third: "Reminder",
  //   fourth: "Category",
  //   fifth: "Owner",
  //   sixth: "Client Name",
  //   seventh: "Due date",
  //   eighth: "Status",
  //   ninth: "Action",
  // };

  const CommonStyleColumn = {
    color: "white",
    fontFamily: "GibsonRegular",
    alignSelf: "center",
    borderRight: `1px solid ${theme.COLORS.table_header_border}`,
    height: "100%",
    display: "flex",
    alignItems: "center",
    letterSpacing: 1,
    justifyContent: "center",
    textAlign: "center",
    fontSize: "1.5vmin",
  };

  const BorderRaidus = 8;
  const headingStyle = {
    height: "77%",
    width: "100%",
    backgroundColor: theme.COLORS.secondary_skyblue,
    borderTopLeftRadius: BorderRaidus,
    borderTopRightRadius: BorderRaidus,
    display: "flex",
    flexDirection: "row",
  };

  return (
    <div style={headingStyle}>
      <div style={{ width: ColoumnWidth.first, ...CommonStyleColumn }}>
        {columnHeadingsReminders.first}
      </div>
      <div style={{ width: ColoumnWidth.second, ...CommonStyleColumn }}>
        {columnHeadingsReminders.second}
      </div>
      <div style={{ width: ColoumnWidth.third, ...CommonStyleColumn }}>
        {columnHeadingsReminders.third}
      </div>
      <div style={{ width: ColoumnWidth.fourth, ...CommonStyleColumn }}>
        {columnHeadingsReminders.fourth}
      </div>
      <div style={{ width: ColoumnWidth.fifth, ...CommonStyleColumn }}>
        {columnHeadingsReminders.fifth}
      </div>
      <div style={{ width: ColoumnWidth.sixth, ...CommonStyleColumn }}>
        {columnHeadingsReminders.sixth}
      </div>
      <div style={{ width: ColoumnWidth.seventh, ...CommonStyleColumn }}>
        {columnHeadingsReminders.seventh}
      </div>
      <div style={{ width: ColoumnWidth.eighth, ...CommonStyleColumn }}>
        {columnHeadingsReminders.eighth}
      </div>
      <div
        style={{
          width: ColoumnWidth.ninth,
          ...CommonStyleColumn,
          borderRight: 0,
        }}
      >
        {columnHeadingsReminders.ninth}
      </div>
    </div>
  );
};

const OtherStatusModal = ({ note, setNote, reminderFilter }) => {
  const dispatch = useDispatch();
  const reminderSingleObj = useSelector(getReminderSingleObject);
  const upadateStatusResponse = useSelector(getreminderStatusUpdate);
  useEffect(() => {
    setNote(reminderSingleObj.note);
  }, [reminderSingleObj]);
  const otherStatusUpdate = () => {
    const updateReminderObject = {
      reminderId: reminderSingleObj?._id,
      status: OTHER,
      note: note,
    };
    dispatch(updateReminderStatus(updateReminderObject)).then(async () => {
      await dispatch(reminderOtherStatusClosed());
      // const filterParams = { reminderfilter: reminderFilter };
      await dispatch(getMyReminders());
    });
    toast.success(upadateStatusResponse.message);
    dispatch(reminderSingleObjectClear());
  };
  const classes = useStyles();
  const heights = {
    desc: "8%",
    proceedbutton: "8%",
    somegapbetween: "2%",
    remainingHeight: "",
  };
  const hDist = {
    headingHeight: "10%",
    remainingHeight: "10%",
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
        }}
      >
        <div
          style={{
            height: hDist.headingHeight,
            width: "100%",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              backgroundColor: theme.COLORS.secondary_skyblue,
              fontSize: "3vmin",
              letterSpacing: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              fontFamily: "GibsonRegular",
            }}
          >
            Add Notes
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
            backgroundColor: theme.COLORS.primary_navyblue,
            padding: "2vmin",
            paddingTop: 0,
          }}
        >
          <div className="cross-icon-position">
            <CancelIcon
              fontSize="large"
              className="cross-icon-style"
              onClick={() => {
                dispatch(reminderOtherStatusClosed());
                dispatch(reminderSingleObjectClear());
              }}
            ></CancelIcon>
          </div>
          <PerfectScrollbar>
            <div className="form-group row note-modal-section">
              <label className="font-weight-bold col-form-label text-warning">
                Client Name :
              </label>
              <label className="col-sm-3 col-form-label">
                {reminderSingleObj?.clientName}
              </label>
              <label className="font-weight-bold col-form-label text-warning">
                Creator Name :
              </label>
              <label className="col-sm-3 col-form-label">
                {reminderSingleObj?.creatorName}
              </label>
            </div>
            <div className="form-group row note-modal-section ">
              <label className="font-weight-bold col-form-label text-warning">
                Owner Name :
              </label>
              <label className="col-sm-3 col-form-label">
                {reminderSingleObj?.ownerName}
              </label>
              <label className=" font-weight-bold col-form-label text-warning">
                Owner Type :
              </label>
              <label className="col-sm-3 col-form-label">
                {reminderSingleObj?.ownertype}
              </label>
            </div>
            <div>
              <CommonInputTextArea
                placeholder="Add notes here...."
                value={note}
                onChange={(e) => setNote(e.target.value)}
              ></CommonInputTextArea>
              <OrangeButton
                onClick={otherStatusUpdate}
                text="Update"
                width="100%"
              ></OrangeButton>
            </div>
          </PerfectScrollbar>
        </div>
      </div>
    </>
  );
};

const CommonInputTextArea = ({
  label = "Sample label",
  onChange,
  value,
  placeholder,
}) => {
  return (
    <section className="common-input-note-textarea">
      <div style={{ width: "100%", minHeight: "100%" }}>
        <textarea
          style={{
            width: "100%",
            height: "13rem",
            padding: "2vmin",
            color: theme.COLORS.dark_navy_blue,
            border: `2px solid ${theme.COLORS.secondary_skyblue}`,
            borderRadius: 5,
            letterSpacing: 1.2,
            backgroundColor: "white",
          }}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        ></textarea>
      </div>
    </section>
  );
};
//#region Right Pane
const RemindersRightPane = (props) => {
  const filterReminderHandler = async (key, data) => {
    const filterParams = { ...props.filteredParams };
    if (key === START_DATE) {
      filterParams.fromreminderdate = data || props.startDateFilter || "";
    }
    if (key === END_DATE) {
      filterParams.toreminderdate = data || props.endDateFilter || "";
    }
    if (key === CREATOR) {
      filterParams.creator = data || "";
    }
    if (key === CATEGORY) {
      filterParams.remindercategory = data || "";
    }
    if (key === STATUS_KEY) {
      filterParams.status = data || "";
    }
    if (key === GROUP) {
      filterParams.group = data || "";
    }
    if (key === OWNER) {
      filterParams.owner = data || "";
    }

    // filterParams.reminderfilter = key === ME ? data : props.reminderFilter;
    // if (key === ME) {
    //   const date = setReminderDate(new Date(), new Date());

    //   filterParams.fromreminderdate = props.startDateFilter
    //     ? props.startDateFilter
    //     : date.startDate;
    //   filterParams.toreminderdate = props.endDateFilter
    //     ? props.endDateFilter
    //     : date.endDate;
    // }
    props.setFilteredParams(filterParams);
    await dispatch(getMyReminders(filterParams));
    setLoading(false);
  };

  const filterReminderHandlerForDate = async (key, data, todayDate) => {
    const filterParams = props.filteredParams;
    if (START_DATE || WEEK || YEAR || MONTH === key)
      filterParams.fromreminderdate =
        START_DATE === key
          ? data
          : props.startDateFilter || WEEK || YEAR || MONTH === key
          ? data
          : "" || "";
    if (END_DATE || WEEK || YEAR || MONTH === key)
      filterParams.toreminderdate =
        END_DATE === key
          ? data
          : props.endDateFilter || WEEK || YEAR || MONTH === key
          ? todayDate
          : "" || "";
    if (CREATOR === key)
      filterParams.creator = CREATOR == key ? data : props.creatorFilter || "";
    if (CATEGORY === key)
      filterParams.remindercategory =
        CATEGORY == key ? data : props.categoryFilter || "";
    if (STATUS_KEY === key)
      filterParams.status = STATUS_KEY == key ? data : props.statusFilter || "";
    if (GROUP === key)
      filterParams.group = GROUP == key ? data : props.userGroupFilter || "";
    if (OWNER === key)
      filterParams.owner = OWNER == key ? data : props.ownerFilter || "";
    // filterParams.reminderfilter = ME == key ? data : props.reminderFilter;
    // if (key === ME) {
    //   const date = setReminderDate(new Date(), new Date());

    //   filterParams.fromreminderdate = props.startDateFilter
    //     ? props.startDateFilter
    //     : date.startDate;
    //   filterParams.toreminderdate = props.endDateFilter
    //     ? props.endDateFilter
    //     : date.endDate;
    // }
    props.setFilteredParams(filterParams);
    await dispatch(getMyReminders(filterParams));
  };
  const [loading, setLoading] = useState(false);
  const [ownerFilterView, setownerFilterView] = useState(false);
  const [statusFilterView, setstatusFilterView] = useState(false);
  const [dateFilterView, setdateFilterView] = useState(false);
  const [groupFilterView, setgroupFilterView] = useState(false);
  const [creatorFilterView, setcreatorFilterView] = useState(false);
  const [categoryFilterView, setcategoryFilterView] = useState(false);
  const brokerage = useSelector(getBrokerInformation);
  const languagePreference = brokerage?.information?.languagepreference || "en";

  const dispatch = useDispatch();
  const categories = useSelector(getCategoryList);

  const handleClearFilter = async () => {
    //props.setOwnerFilter('EVERYONE')
    setIsCustomDate(false);
    setdateFilterView({
      label: translations[languagePreference].custom,
      value: "",
    });
    var filterParams = { reminderFilter: "allReminders" };
    setownerFilterView({ label: translations[languagePreference].everyone, value: "Everyone" });
    setcreatorFilterView({ label: translations[languagePreference].everyone, value: "Everyone" });
    setgroupFilterView({ label: translations[languagePreference].all, value: "All" });
    setcategoryFilterView({ label: translations[languagePreference].all, value: "All" });
    setstatusFilterView({ label: translations[languagePreference].all, value: "All" });

    props.setFilteredParams(filterParams);
    await dispatch(getMyReminders(filterParams));
  };
  const useStyles = makeStyles({
    datePicker: {
      "& .MuiInputBase-root": {
        padding: 0,
        backgroundColor: "#ffffff",
        width: "12.5vw",
        "& .MuiButtonBase-root": {
          padding: 0,
          paddingRight: 10,
          backgroundColor: "#ffffff",
        },
        "& .MuiInputBase-input": {
          padding: 10,
          paddingLeft: 10,
          backgroundColor: "#ffffff",
        },
      },
    },
  });
  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: "10rem",
      backgroundColor: "#ffffff",
    }),
  };
  const classes = useStyles();
  const brokers = useSelector(getBrokers);
  const brokerteam = useSelector(getBrokerTeamMembers);
  const { information } = useSelector(getBrokerInformation);
  const [localbrokerteam, setlocalbrokerteam] = useState([]);
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  useEffect(async () => {
    const queryObject = {};
    
    for (const [key, value] of searchParams.entries()) {
      queryObject[key] = value;
    }
    if (information?._id) {
      //props.setOwnerFilter(information._id);
      props.setStatusFilter("Open");
      //filterReminderHandler(STATUS_KEY, 'Open');
      //filterReminderHandler(OWNER, information._id);
      setstatusFilterView({ label: translations[languagePreference].status, value: "Open" });

      setownerFilterView({
        label: `${information.firstname} ${information.lastname}`,
        value: "intial",
      });
      setIsCustomDate(false);
      setdateFilterView({
        label: translations[languagePreference].custom,
        value: "",
      });
      var filterParams = { owner: information._id, status: "open" };
      //setownerFilterView({label:'Everyone', value:'Everyone'})
      //setstatusFilterView({'label':'All', 'value': ''})
      console.log(queryObject)
      if(queryObject && queryObject.query == 'overdue'){
        //setIsCustomDate(true);
        var start = "2000-01-01";
        var end = new Date();
        const date = setReminderDate(start, end);
        // props.setStartDateFilter(date.startDate)
        // props.setEndDateFilter(new Date())
        setdateFilterView({
          label: translations[languagePreference].today,
          value: "",
        });
        filterParams['toreminderdate'] = date.endDate;
        filterParams['fromreminderdate'] = date.startDate;



      }
      props.setFilteredParams(filterParams);
      await dispatch(getMyReminders(filterParams));
    }
    
    
    // Convert URLSearchParams to a plain JavaScript object
    
    

  }, []);
  useEffect(async () => {
    if (brokerteam && Array.isArray(brokerteam?.brokers))
      setlocalbrokerteam([
        {
          _id: "Everyone",
          value: "Everyone",
          firstname: translations[languagePreference].everyone,
          lastname: "",
        },
        ...brokerteam?.brokers,
      ]);
  }, [brokerteam]);
  const groupList = useSelector(getGroupSelectArray);
  const [localgroupList, setlocalgroupList] = useState([]);
  const locale = languagePreference === "fr" ? frLocale : enLocale;
  useEffect(async () => {
    //setlocalbrokerteam([{_id: 'Everyone', value:'Everyone' , firstname: 'Everyone', lastname: ''} , ...brokerteam?.brokers]);
    if (groupList && groupList.length) {
      setlocalgroupList([{ _id: "All", title: translations[languagePreference].all }, ...groupList]);
    }
  }, [groupList]);

  const [isCustomDate, setIsCustomDate] = useState(false);
  // add filter logic
  const clientFilterChangeHandler = (e) => {
    props.setQuery(e.target.value);
  };
  const dateFilterChangeHandler = (e) => {
    const today = new Date();
    const pastWeek = new Date();
    const pastMonth = new Date();
    const pastYear = new Date();

    pastWeek.setDate(pastWeek.getDate() - 7);
    pastMonth.setDate(pastMonth.getDate() - 30);
    pastYear.setDate(pastYear.getDate() - 365);
    setdateFilterView(e);
    if (e.value == WEEK) {
      var startOfWeek = moment().startOf("week").toDate();
      var endOfWeek = moment().endOf("week").toDate();
      const date = setReminderDate(startOfWeek, endOfWeek);
      props.setStartDateFilter(date.startDate);
      props.setEndDateFilter(date.endDate);
      filterReminderHandlerForDate(WEEK, date.startDate, date.endDate);
      setIsCustomDate(false);
    }
    else if (e.value == MONTH) {
      var start = moment().startOf("month").format("YYYY-MM-DD");
      var end = moment().endOf("month").format("YYYY-MM-DD");
      const date = setReminderDate(start, end);
      props.setStartDateFilter(date.startDate);
      props.setEndDateFilter(date.endDate);
      filterReminderHandlerForDate(MONTH, start, end);
      setIsCustomDate(false);
    } 
    else if (e.value == TODAY) {
      var start = new Date('2000-01-01');
      var end = new Date()
      const date = setReminderDate(start, end);
      props.setStartDateFilter(date.startDate);
      props.setEndDateFilter(date.endDate);
      filterReminderHandlerForDate(MONTH, start, end);
      setIsCustomDate(false);
    } else if (e.value == YEAR) {
      var start = moment().startOf("year").toDate();
      var end = moment().endOf("year").toDate();
      const date = setReminderDate(start, end);
      props.setStartDateFilter(date.startDate);
      props.setEndDateFilter(date.endDate);
      filterReminderHandlerForDate(YEAR, date.startDate, date.endDate);
      setIsCustomDate(false);
    } else if (e.value == CUSTOM) setIsCustomDate(true);
    else if (e.value == "All") {
      filterReminderHandlerForDate(WEEK, null, null);
    }
  };

  const startDateChangeHandler = (e) => {
    const date = setReminderDate(e, e);
    props.setStartDateFilter(date.startDate);
    if (!props.endDateFilter) {
      props.setEndDateFilter(date.endDate);
    }
    filterReminderHandler(START_DATE, date.startDate);
  };

  const endDateChangeHandler = (e) => {
    const date = setReminderDate(e, e);
    props.setEndDateFilter(date.endDate);
    if (!props.startDateFilter) {
      props.setStartDateFilter(date.startDate);
    }
    filterReminderHandler(END_DATE, date.endDate);
  };

  // const reminderChangeHandler = (e) => {
  //   props.setReminderFilter(e.value);
  //   filterReminderHandler(ME, e.value);
  // };

  const statusKeyChangeHandler = (e) => {
    props.setStatusFilter(e.value);
    setstatusFilterView(e);
    if (e.value == "All") {
      console.log("setting status to null");
      filterReminderHandler(STATUS_KEY, null);
    } else filterReminderHandler(STATUS_KEY, e.value);
  };

  const creatorChangeHandler = (e) => {
    props.setCreatorFilter(e[0]?.value);
    filterReminderHandler(CREATOR, e[0]?.value);
  };

  const categoryChangeHandler = (e) => {
    props.setCategoryFilter(e[0]?.value);
    if (e[0]?.value == "All") {
      filterReminderHandler(CATEGORY, null);
    } else filterReminderHandler(CATEGORY, e[0]?.value);
  };

  const ChangeHandler = (e, type) => {
    if (e[0]?.value) {
      e.value = e[0]?.value;
      e.label = e[0]?.label;
    }
    switch (type) {
      case STATUS_KEY:
        setstatusFilterView(e);
        props.setStatusFilter(e.value);
        break;
      case CATEGORY:
        props.setCategoryFilter(e);
        setcategoryFilterView(e);
        break;
      case GROUP:
        props.setUserGroupFilter(e.value);
        setgroupFilterView(e);
        break;
      case OWNER:
        props.setOwnerFilter(e.value);
        setownerFilterView(e);
        break;
      case CREATOR:
        props.setCreatorFilter(e.value);
        setcreatorFilterView(e);
      default:
        break;
    }
    //props.setCategoryFilter(e.value);
    if (["All", "Everyone"].includes(e.value)) {
      filterReminderHandler(type, null);
    } else filterReminderHandler(type, e.value);
  };

  const userGroupChangeHandler = (e) => {
    props.setUserGroupFilter(e[0]?.value);
    if (e[0]?.value == "All") {
      filterReminderHandler(GROUP, null);
    } else filterReminderHandler(GROUP, e[0]?.value);
  };

  const ownerChangeHandler = (e) => {
    props.setOwnerFilter(e[0]?.value);
    filterReminderHandler(OWNER, e[0]?.value);
  };
  const ownerChangeHandler2 = (e) => {
    props.setOwnerFilter(e.value);
    if (e.value == "Everyone") {
      filterReminderHandler(OWNER, null);
    } else {
      filterReminderHandler(OWNER, e.value);
    }
    setownerFilterView(e);
    //filterReminderHandler(OWNER, e[0]?.value);
  };
  return (
    <PerfectScrollbar>
      <div
        style={{
          width: "100%",
          height: "100%",
          padding: "3vw",
          marginBottom: "5rem",
          justifyContent: "center",
          alignItems: "center",
          fontFamily: "GibsonLight",
          color: "grey",
        }}
      >
        <div>
          <div style={{ marginTop: "20px" }}></div>
          <Typography
            variant="h5"
            component="h5"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: 26,
              color: theme.COLORS.primary_navyblue,
            }}
          >
            {translations[languagePreference].filters}
          </Typography>
        </div>
        {loading ? (
          <div
            style={{
              width: "100%",
            }}
          >
            <Loader3Orange></Loader3Orange>
          </div>
        ) : (
          <div />
        )}
        <FormControl sx={{ m: 0, minWidth: 260 }} style={{ marginTop: "20px" }}>
          <div>
            <input
              id="txtQuery"
              placeholder={translations[languagePreference].searchForClient}
              style={{
                backgroundColor: "#ffffff",
                // width: "100%",
                width: "12.5vw",
                display: "inline-flex",
                borderStartEndRadius: "0px",
                borderEndEndRadius: "0px",
              }}
              className="form-control"
              onChange={clientFilterChangeHandler}
            />
          </div>
        </FormControl>
        <div style={{ marginTop: "20px" }}>
          <Typography
            variant="h5"
            component="h5"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: 20,
              color: theme.COLORS.secondary_orange,
            }}
          >
            {translations[languagePreference].dueDate}
          </Typography>
          <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
            <SelectDropdown
              options={getTranslatedOptions(dateOptionList, languagePreference)}
              value={dateFilterView}
              styles={{
                valueContainer: (baseStyles, state) => ({
                  ...baseStyles,
                  width: "12.5vw",
                  backgroundColor: "#ffffff",
                  borderRadius: "5px",
                }),
              }}
              onChange={dateFilterChangeHandler}
            ></SelectDropdown>
          </FormControl>
          <div style={{ width: "250px" }}>
            {isCustomDate ? (
              <div>
                <div>
                  <p style={{ margin: "0px", marginTop: "5px" }}>
                    {translations[languagePreference].from}
                  </p>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <KeyboardDatePicker
                      placeholder={
                        languagePreference === "fr"
                          ? "jj/mm/aaaa"
                          : "mm/dd/yyyy"
                      }
                      cancelLabel={
                        externaltranslations[languagePreference].cancel
                      }
                      todayLabel={
                        languagePreference === "fr" ? "Aujourd'hui" : "Today"
                      }
                      className={classes.datePicker}
                      inputVariant="filled"
                      value={props.startDateFilter}
                      format="MMM dd, yyyy"
                      onChange={startDateChangeHandler}
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div>
                  <p style={{ margin: "0px" }}>
                    {translations[languagePreference].to}
                  </p>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      className={classes.datePicker}
                      inputVariant="filled"
                      value={props.endDateFilter}
                      minDate={props.startDateFilter}
                      format="MMM dd, yyyy"
                      onChange={endDateChangeHandler}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>

        <div style={{ marginTop: "20px" }}>
          <Typography
            variant="h5"
            component="h5"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: 20,
              color: theme.COLORS.secondary_orange,
            }}
          >
            {translations[languagePreference].status}
          </Typography>
          <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
            <SelectDropdown
              placeholder={translations[languagePreference].select}
              options={[
                { label: translations[languagePreference].all, value: "All" },
                ...getTranslatedOptions(statusList, languagePreference),
              ]}
              value={statusFilterView}
              styles={{
                valueContainer: (baseStyles, state) => ({
                  ...baseStyles,
                  width: "12.5vw",
                  backgroundColor: "#ffffff",
                  borderRadius: "5px",
                }),
              }}
              onChange={(e) => ChangeHandler(e, STATUS_KEY)}
            ></SelectDropdown>
          </FormControl>
        </div>

        <div style={{ marginTop: "20px" }}>
          <Typography
            variant="h5"
            component="h5"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: 20,
              color: theme.COLORS.secondary_orange,
            }}
          >
            {translations[languagePreference].creator}
          </Typography>
          <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
            <SelectDropdown
              placeholder={translations[languagePreference].select}
              options={localbrokerteam?.map((indiv) => {
                return {
                  value: indiv?._id,
                  label: `${indiv?.firstname} ${indiv?.lastname}`,
                };
              })}
              styles={{
                valueContainer: (baseStyles, state) => ({
                  ...baseStyles,
                  width: "12.5vw",
                  backgroundColor: "#ffffff",
                  borderRadius: "5px",
                }),
              }}
              style={{
                width: "12.5vw",
                backgroundColor: "#ffffff",
                borderRadius: "5px",
              }}
              onChange={(e) => ChangeHandler(e, CREATOR)}
              value={creatorFilterView}
            ></SelectDropdown>
          </FormControl>
        </div>
        <div style={{ marginTop: "20px" }}>
          <Typography
            variant="h5"
            component="h5"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: 20,
              color: theme.COLORS.secondary_orange,
            }}
          >
            {translations[languagePreference].category}
          </Typography>
          <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
            <SelectDropdown
              placeholder={translations[languagePreference].select}
              options={[
                { label: translations[languagePreference].all, value: "All" },
                ...categories.map((item) => {
                  return {
                    value: item.code,
                    label: item?.title[languagePreference],
                  };
                }),
              ]}
              styles={{
                valueContainer: (baseStyles, state) => ({
                  ...baseStyles,
                  width: "12.5vw",
                  backgroundColor: "#ffffff",
                  borderRadius: "5px",
                }),
              }}
              style={{
                width: "12.5vw",
                backgroundColor: "#ffffff",
                borderRadius: "5px",
              }}
              onChange={(e) => ChangeHandler(e, CATEGORY)}
              value={categoryFilterView}
            />
          </FormControl>
        </div>
        <div style={{ marginTop: "20px" }}>
          <Typography
            variant="h5"
            component="h5"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: 20,
              color: theme.COLORS.secondary_orange,
            }}
          >
            {translations[languagePreference].userGroup}
          </Typography>
          <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
            <SelectDropdown
              placeholder={translations[languagePreference].select}
              // options={[ {label:"All", value:"All"}, ...groupList?.map((grpVal) => {
              //   return {
              //     value: grpVal?._id,
              //     label: grpVal?.title,
              //   };
              // }) ] }
              styles={{
                valueContainer: (baseStyles, state) => ({
                  ...baseStyles,
                  width: "12.5vw",
                  backgroundColor: "#ffffff",
                  borderRadius: "5px",
                }),
              }}
              options={localgroupList?.map((grpVal) => {
                return {
                  value: grpVal?._id,
                  label: grpVal?.title,
                };
              })}
              style={{
                width: "12.5vw",
                backgroundColor: "#ffffff",
                borderRadius: "5px",
              }}
              onChange={(e) => ChangeHandler(e, GROUP)}
              value={groupFilterView}
            ></SelectDropdown>
          </FormControl>
        </div>
        {/* <div style={{ marginTop: "20px" }}>
          <Typography
            variant="h5"
            component="h5"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: 20,
              color: theme.COLORS.secondary_orange,
            }}
          >
            Owner
          </Typography>
          <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
            <Select
              options={brokerteam?.brokers?.map((indiv) => {
                return {
                  value: indiv?._id,
                  label: `${indiv?.firstname} ${indiv?.lastname}`,
                };
              })}
              style={{
                width: "12.5vw",
                backgroundColor: "#ffffff",
                borderRadius: "5px",
              }}
              onChange={ownerChangeHandler}
              values={[{   value: props.ownerFilter,
                label: props.ownerFilter,}]}
            ></Select>
          </FormControl>
        </div> */}
        <div style={{ marginTop: "20px" }}>
          <Typography
            variant="h5"
            component="h5"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: 20,
              color: theme.COLORS.secondary_orange,
            }}
          >
            {translations[languagePreference].owner}
          </Typography>
          <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
            <SelectDropdown
              placeholder={translations[languagePreference].select}
              options={localbrokerteam?.map((indiv) => {
                return {
                  value: indiv?._id,
                  label: `${indiv?.firstname} ${indiv?.lastname}`,
                };
              })}
              value={ownerFilterView}
              // style={{
              //   width: "12.5vw",
              //   backgroundColor: "#ffffff",
              //   borderRadius: "5px",
              // }}
              styles={{
                valueContainer: (baseStyles, state) => ({
                  ...baseStyles,
                  width: "12.5vw",
                  backgroundColor: "#ffffff",
                  borderRadius: "5px",
                }),
              }}
              onChange={(e) => ChangeHandler(e, OWNER)}
            ></SelectDropdown>
          </FormControl>
        </div>
        <div style={{ marginTop: "20px" }}>
          <OrangeButton
            text={translations[languagePreference].clearFilters}
            width="12.5vw"
            onClick={handleClearFilter}
          />
        </div>
        <div style={{ marginTop: "20px" }}></div>
      </div>{" "}
    </PerfectScrollbar>
  );
};

const CompleteReminderModal = ({
  setreminderRedirection,
  reminderRedirection,
}) => {
  const closeModal = () => setreminderRedirection({ isOpen: false });
  const dispatch = useDispatch();
  const brokerage = useSelector(getBrokerInformation);
  const languagePreference = brokerage?.information?.languagepreference || "en";
  // Inline styles for modal and overlay
  const modalStyles = {
    content: {
      backgroundColor: "white",
      borderRadius: "8px",
      width: "300px",
      height: "200px",
      padding: "20px",
      margin: "auto",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      outline: "none",
      border: "none",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.3)", // Semi-transparent overlay
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  };
  return (
    <Modal
      isOpen={reminderRedirection.isOpen}
      onRequestClose={closeModal}
      style={modalStyles} // Apply styles directly to the modal
    >
      <div style={{ textAlign: "center" }}>
        <h3 style={{ margin: "0 0 15px", fontSize: "18px" }}>
          {externaltranslations[languagePreference].modalTitle}
        </h3>
        <p style={{ margin: "0 0 20px", fontSize: "14px", color: "#555" }}>
          
          {externaltranslations[languagePreference].modalTitle}
        </p>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              const updateReminderObject = {
                reminderId: reminderRedirection.reminder?._id,
                status: "completed",
              };
              dispatch(updateReminderStatus(updateReminderObject)).then(() => {
                dispatch(getMyReminders());
              });
              setreminderRedirection({
                isOpen: false,
                link: "",
                reminder: null,
              });
              window.open(reminderRedirection.link, "_blank");
            }}
            style={{ marginRight: "10px", textTransform: "none" }}
          >
            {externaltranslations[languagePreference].yes}
            
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setreminderRedirection({
                isOpen: false,
                link: "",
                reminder: null,
              });
              window.open(reminderRedirection.link, "_blank");
            }}
            style={{ textTransform: "none" }}
          >
            {externaltranslations[languagePreference].no}
            
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default Reminders;
